import BaseStore from './BaseStore'

export class DocumentTemplateStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'document_templates'
  }
}

export default new DocumentTemplateStore()


// WEBPACK FOOTER //
// ./src/stores/DocumentTemplateStore.js